import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import HelpButton from 'help/HelpButton';
import {FONT_PROXIMA_11, FONT_WEIGHT_PROXIMA_REGULAR, FONT_PROXIMA_12} from 'styles/FontConstants';
import {GRAY_DARKER} from 'ui-library/Colors';
import {FloatingPlacement, FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';

/** @package */
export function getSectionNameOrNull({
  sectionName,
  sectionInfoText,
  isCompact = true,
  sectionAddIcon,
}: {
  sectionName?: string;
  sectionInfoText?: string;
  isCompact?: boolean;
  sectionAddIcon?: JSX.Element;
}): JSX.Element | null {
  return sectionName == null && sectionInfoText == null ? null : (
    <SectionName
      sectionName={sectionName}
      isCompact={isCompact}
      infoText={sectionInfoText}
      addIcon={sectionAddIcon}
    />
  );
}

/** @package */
export default function SectionName({
  sectionName,
  isCompact,
  infoText,
  isCollapsible,
  addIcon,
}: {
  sectionName?: string;
  isCompact: boolean;
  infoText?: string;
  isCollapsible?: boolean;
  addIcon?: JSX.Element;
}): JSX.Element | null {
  assert(sectionName != null || infoText != null, 'sectionName or infoText must be provided');
  return (
    <div
      className={css(
        SectionNameStyles.sharedSectionName,
        isCompact && !isCollapsible && SectionNameStyles.compactSectionMarginBottom,
        !isCompact && !isCollapsible && SectionNameStyles.sectionMarginBottom,
        isCompact && SectionNameStyles.compactSectionName,
        !isCompact && SectionNameStyles.sectionName
      )}
    >
      {sectionName}
      <HelpButtonOrNull infoText={infoText} isCompact={isCompact} />
      {addIcon}
    </div>
  );
}

/** @package */
export const SectionNameStyles = StyleSheet.create({
  sharedSectionName: {
    color: GRAY_DARKER,
    textTransform: 'uppercase',
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },
  sectionName: {
    ...FONT_PROXIMA_11,
  },
  compactSectionName: {
    ...FONT_PROXIMA_12,
  },
  compactSectionMarginBottom: {
    marginBottom: 4,
  },
  sectionMarginBottom: {
    marginBottom: 10,
  },
});

export function HelpButtonOrNull({
  infoText,
  isCompact,
}: {
  infoText?: string;
  isCompact: boolean;
}): JSX.Element | null {
  if (infoText != null) {
    return (
      <HelpButton
        renderContent={() => <span className="u-pre-wrap u-normal-font-weight">{infoText}</span>}
        iconClassName={isCompact ? 'u-mini-spacing-left' : 'u-small-spacing-left'}
        placement={FloatingPlacement.TOP}
        interaction={FloatingInteraction.HOVER}
      />
    );
  }
  return null;
}
